import React from 'react';
import ReactDOM from "react-dom";
import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Portfolio from 'Components/Main/Portfolio';
import Header from 'Components/Main/Header/Header';
import Footer from 'Components/Main/Footer/Footer';
import AboutMe from 'Components/Main/AboutMe';
import How from 'Components/Main/How/How';
import NotFound from 'Components/Main/NotFound';

function App() {
  return (
    <div>
      <Header />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Portfolio />} />
          <Route path="/about" element={<AboutMe />} />
          <Route path="/how" element={<How />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
      <Footer />
    </div>
  );
}

const rootElement = document.getElementById("root");
ReactDOM.render(<App />, rootElement)